module.exports = __webpack_public_path__ + "img/sunset-min.322dd1e5.jpg";